import { Component, inject, OnInit } from '@angular/core';
import { NwvoteService } from '../../nw-vote/nwvote.service';
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  projectname = '';
  private readonly _NwvoteService = inject(NwvoteService);
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    localStorage.setItem('userTokenId', '');
    localStorage.setItem('project', '');

    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],

      name: ['', Validators.required],
    });

    this.projectname =
      this.activatedRoute.snapshot.queryParamMap.get('project');

    this.handleLoginRedirectCallback().then((response) => {
    });
  }

  submitCredentials() {
    this._NwvoteService
      .login(this.loginForm.value, this.projectname)
      .subscribe((res: any) => {
        if (JSON.parse(res.d)[0].userToken) {
          localStorage.setItem('username', JSON.parse(res.d)[0].username);
          localStorage.setItem('userTokenId', JSON.parse(res.d)[0].userToken);
          localStorage.setItem('project', this.projectname);
          this.router.navigate(['/', 'vote']);
        }
      });
  }

  async handleLoginRedirectCallback() {
  }

  signOut() {
  }

  if(tokenResponse) {
    const headers = { Authorization: `Bearer ${tokenResponse.accessToken}` };
    this.http
      .get('https://graph.microsoft.com/v1.0/me', { headers })
      .subscribe((response) => {});
  }
}
